
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getTabdata = async () => {
  return await get<ApiResponse<any[]>>("/tabdata").then((res)=>{
      return res
    })
};

 